import React from 'react';

const funFacts = [
  {
    icon: 'flaticon-passport-16',
    stop: '30',
    suffix: '+',
    title: 'Vize Kategorileri',
    delay: ''
  },
  {
    icon: 'flaticon-group',
    stop: '389',
    suffix: '+',
    title: 'Ekip Üyeleri',
    delay: '300ms'
  },
  {
    icon: 'flaticon-life-insurance',
    stop: '4.9',
    suffix: 'k',
    title: 'Vize Süreci',
    delay: '600ms'
  },
  {
    icon: 'flaticon-cooperation',
    stop: '98',
    suffix: '%',
    title: 'Başarı Oranları',
    delay: '900ms'
  }
];

const FunFact = () => {
  return (
    <section className="fun-fact-section-two">
      <div className="auto-container">
        <div className="fact-counter pull-up">
          <div className="row">
            {funFacts.map((fact, index) => (
              <div
                className="counter-block-two col-xl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                key={index}
                data-wow-delay={fact.delay}
              >
                <div className="inner">
                  <i className={`icon ${fact.icon}`}></i>
                  <div className="count-box">
                    <span
                      className="count-text"
                      data-speed="3000"
                      data-stop={fact.stop}
                    >
                      0
                    </span>
                    {fact.suffix}
                  </div>
                  <h6 className="counter-title">{fact.title}</h6>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FunFact;